import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
export function WhyChooseUs() {
  const benefits = ['Gas Safe Registered #972580', 'Fully Insured & Certified', 'Upfront Honest Pricing', 'Local Glasgow Engineers'];
  return <section id="about" className="py-24 relative z-10 bg-[#0a0a0a] border-t border-white/5" data-id="element-262">
      <div className="max-w-7xl mx-auto px-6" data-id="element-263">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-264">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-265">
            <span className="text-[#FFD600] font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-266">
              Why Choose Us
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-267">
              Local Experts You <br data-id="element-268" /> Can Trust
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed" data-id="element-269">
              As a family-run business based in Glasgow, we take pride in
              delivering honest, reliable, and high-quality heating services.
              Our engineers are fully qualified, Gas Safe registered, and
              dedicated to keeping your home warm and safe.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-270">
              {benefits.map((benefit, index) => <li key={index} className="flex items-center gap-3" data-id="element-271">
                  <CheckCircle2 className="w-6 h-6 text-[#FFD600] flex-shrink-0" data-id="element-272" />
                  <span className="text-white font-medium" data-id="element-273">{benefit}</span>
                </li>)}
            </ul>

            <a href="#contact" className="inline-block bg-gradient-primary text-black font-bold text-lg px-8 py-4 rounded-full hover:shadow-[0_0_30px_rgba(255,149,0,0.3)] transition-all duration-300 transform hover:-translate-y-1" data-id="element-274">
              Book an Engineer
            </a>
          </motion.div>

          {/* Right Visual */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-275">
            <div className="absolute inset-0 bg-gradient-primary rounded-3xl blur-2xl opacity-20 transform rotate-3" data-id="element-276"></div>
            <div className="relative rounded-3xl overflow-hidden border border-white/10 bg-brand-card aspect-square" data-id="element-277">
              <img src="https://cdn.magicpatterns.com/uploads/6fbw1yejdXQU7atRN4Cmnm/ChatGPT_Image_Jun_4,_2026,_11_46_17_PM.png" alt="Clydeside Gas Safe Heating — Warmth You Can Trust" className="w-full h-full object-cover" data-id="element-278" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}